


























































import Vue from "vue";
import DataNotFound from "@/components/shared/DataNotFound.vue";
import { ViewJobState } from "@/store/modules/common/interfaces";
import { mapGetters } from "vuex";
import { VIEW_JOB_STATE } from "@/store/modules/common/constants";

export default Vue.extend({
  name: "JobDescriptionCard",
  computed: {
    ViewJobState() {
      return ViewJobState;
    },
    ...mapGetters("common", {
      view_job_state: VIEW_JOB_STATE
    })
  },
  components: { DataNotFound },
  data() {
    return {
      description_copy_snackbar: false,
      formatted_desc: ""
    };
  },
  props: {
    description: {
      type: String
    }
  },
  mounted() {
    this.formatted_desc = this.formattedJobDescription();
  },
  methods: {
    async copy_title() {
      await navigator.clipboard.writeText(this.description);
      this.description_copy_snackbar = true;
    },
    formattedJobDescription() {
      let clean = this.description;

      // Remove b' and trailing ' if present (Python-style bytes string)
      clean = clean.replace(/^b'|'\s*$/g, "");

      // Turn Python-style hex escapes into % escapes (for decodeURIComponent)
      clean = clean.replace(/\\x([0-9a-fA-F]{2})/g, "%$1");

      try {
        clean = decodeURIComponent(clean);
      } catch (e) {
        console.error("Decode error:", e);
      }

      // Convert literal '\n' (two characters) to actual line breaks
      clean = clean.replace(/\\n/g, "\n");

      // Convert actual line breaks to <br>
      clean = clean.replace(/\n/g, "<br>");

      return clean;
    }
  }
});
